<section class="overallTable w-full max-w-6xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <!-- Page header -->
  <header class="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
    <div class="flex flex-col gap-1">
      <p class="text-base text-ink-500">מערכת ניהול גביה</p>
      <h1 class="text-3xl font-bold text-primary-700">{{ header }}</h1>
    </div>

    <a
      routerLink="/prayers/order/add"
      class="btn-2026--primary w-full md:w-auto md:min-w-[200px]"
    >
      <span class="material-symbols-outlined" aria-hidden="true">add_circle</span>
      <span>הזמנה חדשה</span>
    </a>
  </header>

  <!-- Data — mobile cards + tablet/desktop table -->
  <ng-container *ngIf="usersList$ | async as users; else loading">
    <ng-container *ngIf="users.length > 0; else empty">

      <!-- ── Mobile card list (hidden md+) ───────────────────────── -->
      <div class="md:hidden space-y-2">
        <a *ngFor="let user of users"
           [routerLink]="user._id"
           class="card-2026 !p-3 block hover:bg-primary-50/40 transition-colors"
           [attr.aria-label]="user.firstName + ' ' + user.lastName">
          <div class="flex justify-between items-start gap-3">
            <div class="min-w-0 flex-1">
              <div class="font-bold text-ink-800 text-base truncate">
                {{ user.firstName }} {{ user.lastName }}
              </div>
              <div class="text-sm text-ink-600 mt-0.5 truncate">
                <ng-container *ngIf="user.orders && user.orders[0]; else noActivity">
                  <span class="text-ink-500">{{ nedarim }}:</span>
                  {{ user.orders[0].parasha || '—' }}
                </ng-container>
                <ng-template #noActivity>
                  <span class="text-ink-400 italic">אין פעילות</span>
                </ng-template>
              </div>
              <div *ngIf="user.orders && user.orders[0] && user.orders[0].pricePaid < user.orders[0].price"
                   class="text-sm mt-0.5">
                <span class="text-ink-500">{{ commits }}:</span>
                <span class="money money--debt font-semibold">
                  {{ (user.orders[0].price - user.orders[0].pricePaid) | currency : 'ILS' : 'symbol' : '1.0-0' }}
                </span>
              </div>
            </div>
            <div class="text-end shrink-0">
              <div class="text-xs text-ink-500 font-medium">{{ total }}</div>
              <div class="money font-bold text-lg mt-0.5"
                   [class.money--credit]="user.balance > 0"
                   [class.money--debt]="user.balance < 0"
                   [class.money--zero]="user.balance === 0">
                {{ user.balance | currency : 'ILS' : 'symbol' : '1.0-0' }}
              </div>
            </div>
          </div>
        </a>
      </div>

      <!-- ── Tablet+ table (hidden < md) ─────────────────────────── -->
      <div class="hidden md:block overflow-x-auto">
        <table class="table-2026 w-full">
          <thead>
            <tr>
              <th>{{ fullName }}</th>
              <th>{{ nedarim }}</th>
              <th class="text-end">{{ commits }}</th>
              <th class="text-end">{{ total }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let user of users"
              class="cursor-pointer"
              [routerLink]="user._id"
              [attr.aria-label]="user.firstName + ' ' + user.lastName"
            >
              <!-- שם מלא -->
              <td class="font-semibold">
                {{ user.firstName }} {{ user.lastName }}
              </td>

              <!-- נדרים — most recent parasha -->
              <td>
                <ng-container *ngIf="user.orders && user.orders[0]; else noOrder">
                  {{ user.orders[0].parasha || '—' }}
                </ng-container>
                <ng-template #noOrder>
                  <span class="text-ink-400">לא קיים</span>
                </ng-template>
              </td>

              <!-- התחיבויות — outstanding on the most recent order -->
              <td class="text-end">
                <ng-container *ngIf="user.orders && user.orders[0] && user.orders[0].pricePaid < user.orders[0].price; else noCommit">
                  <span class="money money--debt font-semibold">
                    {{ (user.orders[0].price - user.orders[0].pricePaid) | currency : 'ILS' : 'symbol' : '1.0-0' }}
                  </span>
                </ng-container>
                <ng-template #noCommit>
                  <span class="text-ink-400">לא קיים</span>
                </ng-template>
              </td>

              <!-- סך הכל — balance -->
              <td class="text-end">
                <span class="money font-semibold"
                      [class.money--credit]="user.balance > 0"
                      [class.money--debt]="user.balance < 0"
                      [class.money--zero]="user.balance === 0">
                  {{ user.balance | currency : 'ILS' : 'symbol' : '1.0-0' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #empty>
      <div class="card-2026 text-center py-12">
        <i class="material-symbols-outlined text-5xl text-ink-300 mb-2" aria-hidden="true">groups</i>
        <h2 class="text-xl font-semibold text-ink-700">אין עדיין מתפללים במערכת</h2>
        <p class="text-base text-ink-500 mt-1">הוסף משתמש כדי להתחיל</p>
        <a routerLink="/prayers/add" class="btn-2026--primary mt-4 inline-flex">
          <span class="material-symbols-outlined" aria-hidden="true">person_add</span>
          הוסף מתפלל
        </a>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #loading>
    <div class="card-2026 space-y-3">
      <div class="skeleton-2026 h-12 w-full"></div>
      <div class="skeleton-2026 h-12 w-full"></div>
      <div class="skeleton-2026 h-12 w-full"></div>
      <div class="skeleton-2026 h-12 w-full"></div>
    </div>
  </ng-template>

</section>
